<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            ref="grid"
            :actions="actions"
            :beforeSetupGrid="beforeSetupGrid"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            :selectionEnabled="true"
            :freezeHeader="true"
            name="StudentVoucherStatus"
            :expandedOptions="{
                enabled: true,
                template: 'voucher-change-logs',
            }"
        ></dx-grid>

        <v-dialog v-model="updateDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline px-2"
                    >Update Voucher Status</v-card-title
                >

                <div class="px-2 mt-2">
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium">
                            {{
                                clickedRow.hebName +
                                    " " +
                                    clickedRow.lastNameH +
                                    " (" +
                                    clickedRow.branch +
                                    " | " +
                                    clickedRow.class +
                                    ")"
                            }}
                        </div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">Father</div>
                        <div>{{ clickedRow.hname }}</div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">Address</div>
                        <div>
                            {{ clickedRow.busAddress1 }}
                        </div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">
                            Primary Phone
                        </div>
                        <div>{{ clickedRow.homePhone }}</div>
                    </v-layout>
                    <v-select
                        v-model="clickedRow.voucherStatus"
                        label="Voucher Status"
                        class="mb-2 mt-3"
                        :items="voucherStatuses.map((s) => s.status)"
                        clearable
                    ></v-select>
                    <v-textarea
                        v-model="clickedRow.voucherStatusNote"
                        label="Note"
                        class="mb-3"
                        rows="3"
                    ></v-textarea>

                    <v-text-field
                        v-model="clickedRow.caseNumber"
                        label="Case Number"
                        class="mb-3"
                    ></v-text-field
                    ><v-text-field
                        v-model="clickedRow.caseName"
                        label="Case Name"
                        class="mb-3"
                    ></v-text-field>
                    <v-text-field
                        v-model="clickedRow.childsLegalName"
                        label="Child's Legal Name"
                        class="mb-0"
                    ></v-text-field>

                    <v-checkbox
                        class="mt-0 pt-0 mb-3 pb-2"
                        v-model="clickedRow.okToRelease"
                        label="Ok To Release"
                        color="success"
                        hide-details
                    ></v-checkbox>
                </div>
                <v-card-actions class="pt-0 mr-2 mt-0 pb-2">
                    <v-spacer></v-spacer>
                    <v-btn dark color="default" @click="updateDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        dark
                        color="success"
                        @click="save()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="voucherStatusDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline px-2"
                    >Update Voucher Status</v-card-title
                >
                <div class="px-2 mt-2">
                    <div style="overflow-y: auto; height: 300px">
                        <div v-for="(student, index) in selected">
                            <div class="font-weight-medium">
                                {{
                                    student.hebName +
                                        " " +
                                        student.lastNameH +
                                        " (" +
                                        student.branch +
                                        " | " +
                                        student.class +
                                        ")"
                                }}
                            </div>
                            <div class="caption">
                                Father: {{ student.hname }}
                            </div>
                            <div class="caption">
                                {{ student.busAddress1 }}
                            </div>
                            <div class="body-2">
                                {{ student.homePhone }}
                            </div>
                            <v-divider
                                class="my-2"
                                v-if="index + 1 < selected.length"
                            ></v-divider>
                        </div>
                    </div>

                    <v-select
                        v-model="voucherStatus"
                        label="Voucher Status"
                        class="mb-2 mt-3"
                        :items="voucherStatuses.map((s) => s.status)"
                        clearable
                    ></v-select>
                    <v-textarea
                        v-model="note"
                        label="Note"
                        hide-details
                        class="mb-3"
                        rows="3"
                    ></v-textarea>
                </div>
                <v-card-actions class="pt-0 mr-2 mt-0 pb-2">
                    <v-spacer></v-spacer>
                    <v-btn
                        dark
                        color="default"
                        @click="voucherStatusDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        dark
                        color="success"
                        @click="saveInBulk()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import moment from "moment";
import { loadOptions } from "../../utils/smLookup.js";

export default {
    data: () => ({
        title: "Student Voucher Status",

        actions: [],
        userBranch: "",
        url: "",
        regID: "",

        processing: false,
        selected: [],
        updateDialog: false,
        voucherStatusDialog: false,
        clickedRow: {},
        voucherStatuses: [],
        voucherStatus: "",
        note: "",
        filter: "",

        rules: {
            required: (value) => !!value || "Required.",
        },

        columns: [
            {
                label: "Last Name",
                field: "lastName",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "First Name",
                field: "engName",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Name H",
                field: "lastNameH",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "First Name H",
                field: "hebName",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Student ID",
                field: "studentID",
                link: "StudentView",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "familyID",
                label: "Account ID",
                link: "Account View",
                format: "",
                template: "link-action-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                showLink: (row) => {
                    return true;
                },
            },
            {
                label: "Voucher Status",
                field: "voucherStatus",
                template: "text-color-cell-template",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Ok To Release",
                field: "okToRelease",
                format: "",
                visible: true,
                type: "boolean",
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Note",
                field: "voucherStatusNote",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Case Number",
                field: "caseNumber",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Case Name",
                field: "caseName",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Childs Legal Name",
                field: "childsLegalName",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Start Date",
                field: "startDate",
                type: "date",
                format: "MM/dd/yyyy",
                visible: true,
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Building",
                field: "building",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Branch",
                field: "branch",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Grade",
                field: "class",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Section",
                field: "section",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "DOB",
                field: "dob",
                type: "date",
                format: "MM/dd/yyyy",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Age",
                field: "age",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Home Phone",
                field: "homePhone",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Address",
                field: "address1",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Is Applicant",
                field: "isApplicant",
                format: "",
                type: "boolean",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            // {
            //     label: "Family Voucher Count",
            //     field: "familyVoucherCount",
            //     format: "",
            //     visible: true,
            //     filterType: "",
            //     filterValues: [],
            //     filterValue: null,
            //     selectedFilterOperation: null,
            // },
            {
                label: "Family Has Vouchers",
                field: "familyHasVouchers",
                format: "",
                type: "boolean",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Has Voucher",
                field: "hasVoucher",
                format: "",
                type: "boolean",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Has Only Applicant Students",
                field: "hasOnlyApplicantStudents",
                format: "",
                type: "boolean",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    watch: {},
    async created() {
        this.columns.find((c) => c.field == "familyID").linkAction = (
            account,
        ) => {
            this.toAccount(account);
        };
    },
    beforeDestroy() {},
    methods: {
        async beforeSetupGrid() {
            this.userBranch = this.$store.state.authentication.branch;

            await this.loadVoucherStatuses();

            this.columns.find(
                (c) => c.field == "voucherStatus",
            ).getTextColor = (value, row) => {
                if (!value) return;

                const vhStatus = this.voucherStatuses.find(
                    (s) => s.status == value,
                );

                return vhStatus && vhStatus.color ? vhStatus.color : "";
            };

            this.actions.push({
                text: "Update Voucher Status",
                action: this.openVoucherStatus,
                showOnSelection: true,
            });

            let url =
                "voucherStudentStatus?" +
                (this.userBranch != "null"
                    ? "branch=" + this.userBranch
                    : "branch=");

            await this.loadRegID();

            const terms = await this.getTerms();

            this.actions.push({
                text: "Select Filter",
                placeholder: "Select Filter",
                type: "select",
                values: [
                    "New Family – Blank Status",
                    "Voucher Family – Blank Status",
                ],
                value: this.filter,
                onSelected: this.onFilterSelected,
                clearable: true,
                width: "250px",
            });

            this.actions.push({
                text: "Select Term",
                type: "select",
                values: terms,
                value: this.regID,
                onSelected: this.onTermSelected,
            });

            this.url = url +=
                "&regID=" +
                this.regID +
                "&onlyApplicantEmptyStatus=&hasVoucherEmptyStatus=";
        },
        async loadRegID() {
            this.regID = await this.$http.get(
                "api/allStudents/getUpcomingYearRegID",
            );
        },
        async getTerms() {
            return await this.$http.get("api/allStudents/getRegTerms");
        },
        async loadVoucherStatuses() {
            const statuses = await this.$http.get(
                "api/VoucherStudentStatus/GetVoucherStatuses",
            );

            this.voucherStatuses = statuses.sort(
                (a, b) => a.sortOrder - b.sortOrder,
            );
        },
        onTermSelected(value) {
            this.regID = value;

            let url =
                "voucherStudentStatus?" +
                (this.userBranch != "null"
                    ? "branch=" + this.userBranch
                    : "branch=");

            this.url = url +=
                "&regID=" +
                this.regID +
                "&onlyApplicantEmptyStatus=" +
                this.getOnlyApplicantEmptyStatusFilter() +
                "&hasVoucherEmptyStatus=" +
                this.getHasVoucherEmptyStatusFilter();

            this.$refs.grid.reloadDataSource(this.url);
        },
        onFilterSelected(value) {
            this.filter = value;

            let url =
                "voucherStudentStatus?" +
                (this.userBranch != "null"
                    ? "branch=" + this.userBranch
                    : "branch=");

            this.url = url +=
                "&regID=" +
                this.regID +
                "&onlyApplicantEmptyStatus=" +
                this.getOnlyApplicantEmptyStatusFilter() +
                "&hasVoucherEmptyStatus=" +
                this.getHasVoucherEmptyStatusFilter();

            this.$refs.grid.reloadDataSource(this.url);
        },
        getOnlyApplicantEmptyStatusFilter() {
            return this.filter == "New Family – Blank Status";
        },
        getHasVoucherEmptyStatusFilter() {
            return this.filter == "Voucher Family – Blank Status";
        },
        toAccount(row) {
            this.$router.push({
                name: "Account View",
                params: {
                    id: row.familyID,
                },
                query: {
                    limitView: true,
                },
            });
        },
        onRowClicked(row) {
            this.clickedRow = JSON.parse(JSON.stringify(row));

            this.updateDialog = true;
        },
        openVoucherStatus() {
            this.selected = JSON.parse(
                JSON.stringify(this.$refs.grid.getSelectedRowsData()),
            );

            this.voucherStatusDialog = true;
        },
        showLink() {
            return (
                !this.$store.state.authentication.branch ||
                this.$store.state.authentication.branch == "null"
            );
        },
        async save() {
            try {
                this.processing = true;

                const today = moment().format("YYYY-MM-DD HH:mm:ss");

                await this.$http.post("api/allStudents/saveVoucherStatus", [
                    {
                        studentID: this.clickedRow.studentID,
                        status: this.clickedRow.voucherStatus,
                        note: this.clickedRow.voucherStatusNote,
                        caseNumber: this.clickedRow.caseNumber,
                        caseName: this.clickedRow.caseName,
                        childsLegalName: this.clickedRow.childsLegalName,
                        okToRelease: this.clickedRow.okToRelease,
                        lastUpdated: today,
                        updatedBy: this.$store.state.authentication.user,
                    },
                ]);

                this.processing = false;
                this.updateDialog = false;

                this.$notify({
                    text: "Changes Saved",
                    group: "notification",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        async saveInBulk() {
            try {
                this.processing = true;

                const today = moment().format("YYYY-MM-DD HH:mm:ss");

                await this.$http.post(
                    "api/allStudents/saveVoucherStatus",
                    this.selected.map((student) => ({
                        studentID: student.studentID,
                        status: this.voucherStatus,
                        note: this.note,
                        lastUpdated: today,
                        updatedBy: this.$store.state.authentication.user,
                    })),
                );

                this.voucherStatus = "";
                this.note = "";
                this.processing = false;
                this.voucherStatusDialog = false;

                this.$notify({
                    text: "Changes Saved",
                    group: "notification",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
.v-btn__content {
    color: unset;
}
</style>
